// @flow
import $ from 'jquery';
import maskInput from '../../../utils/maskInput';
import JQueryView, { on, removeInvalidFeedback } from '../../common/JQueryView';
import { informationSource } from '../../../models/User';
import SearchAddressForm from '../../common/SearchAddressForm';

export default class FormView extends JQueryView {
  searchAddress: Object;

  constructor() {
    super('.simple_form');
    this.searchAddress = new SearchAddressForm('.simple_form');

    this.render();
  }

  @on({ event: 'change', selector: '#user_information_source_id' })
  onChangeInformationSourceId() {
    this.render();
  }

  @on({ event: 'blur', selector: '.form-group-float, .form-control' })
  onBlurFormControl(event: any) {
    const target = $(event.target);
    if (target.hasClass('date-field2') && $('.show-calendar').is(':visible')) {
      target.addClass('form-control-active');
      target.addClass('focus');
    } else {
      if (target.val().length === 0) {
        target.removeClass('form-control-active');
      } else {
        target.addClass('form-control-active');
        target.removeClass('is-invalid');
        removeInvalidFeedback(target);
      }
    }
  }

  render() {
    const InformationSourceId = $('#user_information_source_id').val();
    $('.display-information-source-note').css(
      'display',
      parseInt(InformationSourceId) === informationSource.other
        ? 'block'
        : 'none',
    );
    maskInput();
  }
}
